module.exports = __webpack_public_path__ + "img/bus.23b82749.svg";